import React from 'react';
import { Container, Row, Col, Button, Form, FormGroup, Label, Input, FormText } from 'reactstrap';
import Section from "./components/Section";

class ContactForm extends Section {

  constructor(props) {
		super(props);
		//console.log("About Constructor", props);
		this.aboutRef = React.createRef();
	}

	componentDidMount() {
		this.props.updateRef(this.props.title, this.aboutRef);
	}

  styles = {
    ...Section.styles,
  }

  render() {
    return (
      <div ref={this.aboutRef} style={this.styles.mainContainer}>
        <Container className="bg-light" style={this.styles.contentContainer}>
          <Row>
            <Col>
              <h1 style={this.styles.title} className="text-center">{this.props.title}</h1>
            </Col>
          </Row>
          <Row>
            <Col md={{size: 8, offset: 2}}>
              <Form name="contact" method="POST" data-netlify="true">
                <input type="hidden" name="form-name" value="contact" />
                <FormGroup>
                  <Label>Name: </Label>   
                  <Input type="text" name="name" />
                </FormGroup>
                <FormGroup>
                  <Label>Email: </Label>   
                  <Input type="email" name="email" />
                </FormGroup>
                <FormGroup>
                  <Label>Phone: </Label>   
                  <Input name="phone" />
                </FormGroup>
                <FormGroup>
                  <Label>Message: </Label>
                  <Input type="textarea" name="message"></Input>
                </FormGroup>
                <FormGroup>
                  <Button color={'success'} style={{ padding: "0.5rem 2rem"}} type="submit">Send</Button>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
};


export default ContactForm;